import MediaListView from 'shared/components/organisms/MediaListView/MediaListView';

export default MediaListView;
